const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  messages:state=>state.user.messages,
  token: state => state.user.token,
  adminToken: state => state.user.adminToken,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  user: state => state.user.user,
  // xrs特定用户的 userId
  xrsUserId: () => '2087857645720571904',
  isDefault:state => state.user.defaultPassword,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,
  permission_routes: state => state.permission.routes,
  indexPage: state => state.permission.indexPage,
  topbarRouters:state => state.permission.topbarRouters,
  defaultRoutes:state => state.permission.defaultRoutes,
  sidebarRouters:state => state.permission.sidebarRouters,
  shipmentCount:state => state.UserStats.shipmentCount,
  entrepotCount:state => state.UserStats.entrepotCount,
  // 添加获取时间戳的 getter
  shipmentLastUpdated: state => state.UserStats.shipmentLastUpdated,
  entrepotLastUpdated: state => state.UserStats.entrepotLastUpdated,
  dict: state => state.dict.dict,
}
export default getters

